import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import type { EmarsysAccountCreatedEmailRequest } from './model/EmarsysAccountCreatedEmailRequest';
import type { EmarsysDefaultResponse } from './model/EmarsysDefaultResponse';

export const useEmarsysSendAccountCreatedEmail = (): UseMutationResult<
    EmarsysDefaultResponse,
    unknown,
    EmarsysAccountCreatedEmailRequest
> =>
    useBffPostMutation<EmarsysDefaultResponse, EmarsysAccountCreatedEmailRequest>(
        '/emarsys/email/account-created',
        [],
    );
